// TODO we should generate this file
import { Badge } from "@freightsimple/ui-core/Display/Badge";
import { TemperatureHandling } from "@freightsimple/generated-dashboard-openapi-client/models/TemperatureHandling";

interface TemperatureHandlingType {
  name: string;
  type: TemperatureHandling;
  // We surface refrigerated/frozen so customers see the full range of
  // handling, but we don't actually offer those services — selecting them
  // only ever leads to a "no quotes" dead-end. Keep them visible but
  // unselectable, flagged "Not currently supported".
  disabled?: boolean;
}

const temperatureHandlingTypes: TemperatureHandlingType[] = [
  {
    name: "No Special Handling",
    type: TemperatureHandling.NoSpecialHandling,
  },
  {
    name: "Protect From Freezing",
    type: TemperatureHandling.ProtectFromFreezing,
  },
  {
    name: "Keep Refrigerated",
    type: TemperatureHandling.KeepRefrigerated,
    disabled: true,
  },
  {
    name: "Keep Frozen",
    type: TemperatureHandling.KeepFrozen,
    disabled: true,
  },
];

// Muted pill rendered to the right of an unsupported option's label. Neutral
// so it reads correctly inside the greyed-out disabled row.
function NotSupportedPill_() {
  return (
    <Badge
      label="Not currently supported"
      variant="neutral"
      size="small"
      shape="pill"
    />
  );
}

export function getTemperatureHandlingTypesForDropdown() {
  return temperatureHandlingTypes.map((t) => {
    return {
      value: t.type,
      label: t.name,
      disabled: t.disabled,
      trailingIcon: t.disabled ? <NotSupportedPill_ /> : undefined,
    };
  });
}
